import React from "react";
import { forwardRef } from "react";
import type { JSX } from "react";

export type Props = Omit<React.JSX.IntrinsicElements["button"], "loading"> & {
  loading?: boolean;
  renderEvenIfLoading?: boolean;
};

const Button = forwardRef<HTMLButtonElement, Props>(
  (
    {
      type = "button",
      className: _class = "",
      loading,
      renderEvenIfLoading,
      disabled,
      children,
      ...props
    },
    ref,
  ) => (
    <button
      {...props}
      className={`${_class}`}
      disabled={disabled || loading}
      type={type}
      ref={ref}
    >
      {renderEvenIfLoading
        ? children
        : loading
        ? <span className="loading loading-spinner" />
        : children}
    </button>
  ),
);

export default Button;
